import { useAtomValue } from 'jotai';

import type { Country } from '../../entities/Country';
import type { PaymentMethodType } from '../../entities/enums';

import {
  maintenanceInfoAtom,
  hideCreditCardAtom,
  maintenanceCreditCardAtom,
  hideHkEWalletAtom,
  maintenanceHkEWalletAtom,
  hidePayPalAtom,
  maintenancePayPalAtom,
  hideIdEwalletAtom,
  hideIdOnlineBankingAtom,
  hideQrisAtom,
  maintenanceIdEWalletAtom,
  maintenanceIdOnlineBankingAtom,
  maintenanceQrisAtom,
  hideFpxAtom,
  maintenanceFpxAtom,
  hidePayNowQrAtom,
  hidePhEWalletAtom,
  hidePhOnlineBankingAtom,
  maintenancePhEWalletAtom,
  maintenancePhOnlineBankingAtom,
  maintenancePayNowQrAtom,
  hidePromptPayAtom,
  hideThOnlineBankingAtom,
  maintenancePromptPayAtom,
  maintenanceThOnlineBankingAtom,
  hideFpsAtom,
  maintenanceFpsAtom,
  hidePhBnplAtom,
  maintenancePhBnplAtom,
} from './MaintenanceStore';
import { getDefaultPaymentMethod } from './getDefaultPaymentMethod';

interface Props {
  paymentMethod: PaymentMethodType;
  country: Country;
}

const useMaintenance = ({ paymentMethod, country }: Props) => {
  const maintenanceInfo = useAtomValue(maintenanceInfoAtom);
  const hideCreditCard = useAtomValue(hideCreditCardAtom);
  const maintenanceCreditCard = useAtomValue(maintenanceCreditCardAtom);
  const hideHkEWallet = useAtomValue(hideHkEWalletAtom);
  const maintenanceHkEWallet = useAtomValue(maintenanceHkEWalletAtom);
  const hidePayPal = useAtomValue(hidePayPalAtom);
  const maintenancePayPal = useAtomValue(maintenancePayPalAtom);
  const hideIdOnlineBanking = useAtomValue(hideIdOnlineBankingAtom);
  const maintenanceIdOnlineBanking = useAtomValue(
    maintenanceIdOnlineBankingAtom,
  );
  const hideIdEwallet = useAtomValue(hideIdEwalletAtom);
  const maintenanceIdEwallet = useAtomValue(maintenanceIdEWalletAtom);
  const hideQris = useAtomValue(hideQrisAtom);
  const maintenanceQris = useAtomValue(maintenanceQrisAtom);
  const hideFpx = useAtomValue(hideFpxAtom);
  const maintenanceFpx = useAtomValue(maintenanceFpxAtom);
  const hidePhOnlineBanking = useAtomValue(hidePhOnlineBankingAtom);
  const maintenancePhOnlineBanking = useAtomValue(
    maintenancePhOnlineBankingAtom,
  );
  const hidePhEWallet = useAtomValue(hidePhEWalletAtom);
  const maintenancePhEWallet = useAtomValue(maintenancePhEWalletAtom);
  const hidePayNowQr = useAtomValue(hidePayNowQrAtom);
  const maintenancePayNowQr = useAtomValue(maintenancePayNowQrAtom);
  const hideThOnlineBanking = useAtomValue(hideThOnlineBankingAtom);
  const maintenanceThOnlineBanking = useAtomValue(
    maintenanceThOnlineBankingAtom,
  );
  const hidePromptPay = useAtomValue(hidePromptPayAtom);
  const maintenancePromptPay = useAtomValue(maintenancePromptPayAtom);
  const hideFps = useAtomValue(hideFpsAtom);
  const maintenanceFps = useAtomValue(maintenanceFpsAtom);
  const hidePhBnpl = useAtomValue(hidePhBnplAtom);
  const maintenancePhBnpl = useAtomValue(maintenancePhBnplAtom);

  const defaultPaymentMethod = getDefaultPaymentMethod(paymentMethod, country, [
    maintenanceCreditCard,
    maintenanceHkEWallet,
    maintenancePayPal,
    maintenanceIdOnlineBanking,
    maintenanceIdEwallet,
    maintenanceQris,
    maintenanceFpx,
    maintenancePhOnlineBanking,
    maintenancePhEWallet,
    maintenancePayNowQr,
    maintenanceThOnlineBanking,
    maintenancePromptPay,
    maintenanceFps,
    maintenancePhBnpl,
  ]);

  return {
    maintenanceInfo,
    hideCreditCard,
    maintenanceCreditCard,
    hideHkEWallet,
    maintenanceHkEWallet,
    hidePayPal,
    maintenancePayPal,
    hideIdOnlineBanking,
    maintenanceIdOnlineBanking,
    hideIdEwallet,
    maintenanceIdEwallet,
    hideQris,
    maintenanceQris,
    hideFpx,
    maintenanceFpx,
    hidePhOnlineBanking,
    maintenancePhOnlineBanking,
    hidePhEWallet,
    maintenancePhEWallet,
    hidePayNowQr,
    maintenancePayNowQr,
    maintenanceThOnlineBanking,
    hideThOnlineBanking,
    maintenancePromptPay,
    hidePromptPay,
    hideFps,
    maintenanceFps,
    hidePhBnpl,
    maintenancePhBnpl,
    defaultPaymentMethod,
  };
};

export default useMaintenance;
